// Süper admin › Şube Entegrasyonları (Entegrasyonlara Genel Bakış) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.integrationsOverview';

export const integrationsOverviewGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Şube Entegrasyonları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Tüm şirketlerin şubelerine bağlı pazaryeri ve yemek platformu entegrasyonlarını tek tabloda görürsünüz. En sık kullanım: yeni bir şubeye kod girmeden önce o kodun başka bir yerde kullanılıp kullanılmadığını kontrol etmek. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve kayıt sayısı'),
    filters: t(`${G}.regions.filters`, 'Arama ve filtreler'),
    table: t(`${G}.regions.table`, 'Entegrasyon tablosu'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne gösterir?'),
      text: t(`${G}.s1.text`, 'Başlıktaki etiket, seçili filtrelere uyan toplam entegrasyon kaydı sayısını gösterir. Pencere yalnız görüntüleme içindir; buradan entegrasyon değiştirilmez.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Kod çakışmasını arayın'),
      text: t(`${G}.s2.text`, '"Kod, şirket, mağaza ara..." kutusuna kodu yazın. Arama şirket adı, platform, mağaza adı, şube kimliği ve kod alanlarında (Restaurant ID, Seller ID, App Secret, Restaurant Secret, API Key) kelimenin geçtiği kayıtları bulur.'),
      tips: [
        t(`${G}.s2.tip1`, 'Sonuç çıkmazsa yeşil "bu kod kullanımda değil" satırı görünür: kod başka bir şubede kayıtlı değildir, gönül rahatlığıyla kullanabilirsiniz.'),
        t(`${G}.s2.tip2`, 'Kontrol yaparken Platform, Şirket ve Şube filtrelerini boş bırakın; filtre seçiliyse yalnız o kapsamda aranır ve "kullanımda değil" sonucu yanıltıcı olabilir.'),
        t(`${G}.s2.tip3`, 'API Secret sütunu aramaya dahil değildir.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Platform, şirket ve şubeye göre süzün'),
      text: t(`${G}.s3.text`, 'Platform listesinden tek bir platformu (Yemeksepeti, Getir, Migros Yemek, Uber Eats, Trendyol, N11, Hepsiburada, Amazon, Pazarama, PttAVM) seçebilirsiniz. Şube filtresi, önce bir Şirket seçildikten sonra açılır ve o şirketin şubelerini listeler.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Kod sütunlarını okuyun'),
      text: t(`${G}.s4.text`, 'Platformlar aynı bilgiye farklı ad verdiği için kod sütunları birden çok adı birlikte taşır. Her kodun yanındaki kopyala simgesiyle değeri panoya alabilirsiniz; Durum sütunu entegrasyonun Aktif / Pasif olduğunu gösterir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Yemeksepeti: Remote Code = "Restaurant ID / Remote Code / Store ID" sütunu; Chain Code = "App Secret / Chain Code / XApiKey" sütunu.'),
        t(`${G}.s4.tip2`, 'Platform etiketi turuncu ise yemek platformu, mavi ise pazaryeridir.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s5.title`, '5. Sayfalar arasında gezinin'),
      text: t(`${G}.s5.text`, 'Alttaki sayfalama ile sayfa başına 10, 25, 50 veya 100 kayıt gösterebilirsiniz. Arama ya da filtre değiştiğinde ilk sayfaya dönülür.'),
    },
  ],
});
